import { EventsFormulaFields } from 'src/tables/EventsTable/configs/EventsTableColumnsConfig';
import { ListingDetailedMetrics } from 'src/WebApiController';

import { ColumnPersonalizationFlags } from '../columnUtils.types';
import { EventsTableColumnId } from './eventsColumnUtils.types';

export const EVENTS_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG: Partial<ColumnPersonalizationFlags> =
  {
    isHiddenByDefault: true,
    isNumeric: true,
  };

export const FORMULA_FIELD_TO_COLUMN_ID: Record<
  keyof EventsFormulaFields,
  EventsTableColumnId | undefined
> = {
  ['actualStr']: EventsTableColumnId.ActualSTR,
  ['expectedStr']: undefined,
  ['liftPercentage']: EventsTableColumnId.LiftPercentage,
  ['listedAtp']: EventsTableColumnId.ListedAtp,
  ['revenue']: EventsTableColumnId.Revenue,
  ['totalAtp']: EventsTableColumnId.ATP,
  ['totalCost']: EventsTableColumnId.TotalCost,
  ['totalGrossProfit']: EventsTableColumnId.Profit,
  ['totalListPrice']: undefined,
  ['totalListedQuantity']: EventsTableColumnId.ListedQty,
  ['totalListedValue']: undefined,
  ['totalNetProceeds']: undefined,
  ['totalSoldCost']: EventsTableColumnId.SoldCost,
  ['totalSoldQuantity']: EventsTableColumnId.SoldQty,
  ['totalTicketQuantity']: EventsTableColumnId.TotalQty,
  ['totalUnsoldListPrice']: EventsTableColumnId.UnsoldProceeds,
  ['totalUnsoldCost']: EventsTableColumnId.UnsoldCost,
  ['totalUnsoldQuantity']: EventsTableColumnId.UnsoldQty,
  ['boostRemainingBudget']: EventsTableColumnId.BoostRemainingBudget,
  ['qtySoldL1']: EventsTableColumnId.QtySoldL1,
  ['qtySoldL3']: EventsTableColumnId.QtySoldL3,
  ['qtySoldL7']: EventsTableColumnId.QtySoldL7,
};

export const LISTING_METRIC_TEST_DATA: ListingDetailedMetrics = {
  str: 1,
  liftPerc: 1,
  listedATP: 1,
  rvn: 1,
  atp: 1,
  ttlCst: 1,
  pandL: 1,
  ttlListPrc: 1,
  listQty: 1,
  netProcs: 1,
  soldCst: 1,
  soldQty: 1,
  tktQty: 1,
  ttlUnsoldListPrc: 1,
  unsoldQty: 1,
} as ListingDetailedMetrics;
